'use strict';

angular.module('theme').component('testWeekButton', {
	templateUrl: 'component/test-week-button.html',
	controller: function ($scope, $cookies) {
		$scope.type = $cookies.get('test-week') ? 'Test' : 'Abonnemang';

		var expires = moment().add(1, 'month').toDate();

		$scope.$watch('type', function (type) {
			if (type === 'Test') {
				$cookies.put('test-week', type, {
					path: '/',
					expires: expires
				});
			} else {
				$cookies.remove('test-week', {
					path: '/'
				});
			}
		});

	}
});
